export default __webpack_public_path__ + "static/media/setor-icon.f4e958f1.svg";